angular.
module("dx.webapp.importStudents").
controller("DxImportStudentsRouteController", function ImportStudentsRouteController(
	$scope,
	$timeout,
	$location,

	NodeRepository,
	Node,
	validationService,
	dxApi,
	dxSession,
	RoleTypeEnum,
	DX_URLS,
	DX_IMPORT_STUDENTS_ACCESSIBILITY_CODE,
	dxLocalize,
	passwordValidationService,

	ngPasteFromErrors
) {
	"use strict";

	var self = this;

	self.RoleTypeEnum = RoleTypeEnum;
	self.role = dxSession.getRole();
	self.Urls = DX_URLS;
	self.AccessibilityCodes = DX_IMPORT_STUDENTS_ACCESSIBILITY_CODE;

	self.exampleVisible = false;

	self.nodes = [];
	self.currentNode = null;

	self.userData = [];
	self.formattedUserData = [];
	self.isPasswordUsed = false;
	self.batchErrors = [];
	self.job = null;
	self.importStatus = "";
	self.isImportingStudents = false;
	self.hasImportedStudents = false;
	// This is not used but is required in order to be able to use the placeholder directive.
	self.pastedText = "";

	var refreshTimeout = null;
	var scopeDestroyed = false;

	var studentCode = "studentCode";
	self.columns = ["email", "firstName", "lastName", studentCode, "accessibilityCodes", "password"];
	var studentCodeInsertIndex = self.columns.indexOf(studentCode);

	switch (self.role.roleType) {
		case self.RoleTypeEnum.MASTER:
			NodeRepository.list().then(function success(response) {
				response.nodes.map(function nodes(n) {
					self.nodes.push(new Node(n));
				});
			});
			break;
		case self.RoleTypeEnum.ACCOUNTMANAGER:
			NodeRepository.load(self.role.organizationId).then(function onNodeLoadSuccess(node) {
				self.currentNode = node;
				if (self.currentNode.disabledStudentCodes) {
					self.columns.splice(self.columns.indexOf(studentCode), 1);
				}
			});
	}

	self.onBeforePaste = function onBeforePaste(data) {
		self.batchErrors = [];
		self.hasImportedStudents = false;

		// accessibility codes and password are an optional column
		// add empty columns until we are at 6 columns
		var dataRows = data.match(/[^\r\n]+/g);
		var newData = "";

		for (var i = 0; i < dataRows.length; i++) {
			var splitDataRows = dataRows[i].split("\t");

			if (splitDataRows.length === self.columns.length - 2) {
				newData += dataRows[i] + "\t\t\n";
			} else if (splitDataRows.length === self.columns.length - 1) {
				newData += dataRows[i] + "\t\n";
			} else {
				newData += dataRows[i] + "\n";
			}
		}

		return newData;
	};

	function validateEmail(row, rowData) {
		var isValid = validationService.isEmailValid(row.email.trim(), true);

		if (!isValid) {
			self.batchErrors.push(dxLocalize.get("ImportStudents.Error.InvalidEmail", rowData.index + 1, rowData.source));
		}

		return isValid;
	}

	function validateStudentCode(row, rowData) {
		if (self.currentNode.disabledStudentCodes) {
			return true;
		}

		var isValid = validationService.isStudentCodeValid(row.studentCode.trim());

		if (!isValid) {
			self.batchErrors.push(dxLocalize.get("ImportStudents.Error.InvalidStudentCode", rowData.index + 1, rowData.source));
		}

		return isValid;
	}

	function validateName(row, rowData) {
		var isFirstNameValid = validationService.isNameValid(row.firstName.trim());
		var isLastNameValid = validationService.isNameValid(row.lastName.trim());

		if (!isFirstNameValid) {
			self.batchErrors.push(dxLocalize.get("ImportStudents.Error.InvalidFirstName", rowData.index + 1, rowData.source));
		}

		if (!isLastNameValid) {
			self.batchErrors.push(dxLocalize.get("ImportStudents.Error.InvalidLastName", rowData.index + 1, rowData.source));
		}

		return isFirstNameValid && isLastNameValid;
	}

	function validateAccessibilityCodes(row, rowData) {
		row.accessibilityCodes = row.accessibilityCodes.trim().toUpperCase();
		var accessibilityCodes = row.accessibilityCodes;

		if (accessibilityCodes) {
			for (var i = 0; i < accessibilityCodes.length; i++) {
				if (Object.values(self.AccessibilityCodes).indexOf(accessibilityCodes[i]) === -1) {
					self.batchErrors.push(dxLocalize.get("ImportStudents.Error.InvalidAccessibilityCode",
						accessibilityCodes[i], rowData.index + 1, rowData.source));
					return false;
				}
			}
		}
		return true;
	}

	function validatePassword(row, rowData) {
		//Password is optional when importing users, if no password, one will be generated automatically. An empty password is okay.
		if (!row.password) {
			return true;
		} else if (passwordValidationService.validate(row.password)) {
			self.batchErrors.push(dxLocalize.get("ImportStudents.Error.InvalidPassword", rowData.index + 1, rowData.source));

			return false;
		}

		return true;
	}

	self.onValidateEntry = function onValidateEntry(row, rowData) {
		return validateEmail(row, rowData) && validateStudentCode(row, rowData) && validateName(row, rowData) &&
			validateAccessibilityCodes(row, rowData) && validatePassword(row, rowData);
	};

	self.onEntryError = function onEntryError(error, rowData) {
		if (error === ngPasteFromErrors.invalidColumnLength) {
			self.batchErrors.push(dxLocalize.get("ImportStudents.Error.InvalidColumnCount", rowData.index + 1,
				rowData.expectedLength - 2, rowData.expectedLength, rowData.actualLength, rowData.source));
		}
	};

	$scope.$watch("vm.currentNode", function nodeChanged() {
		if (!self.currentNode || self.role.roleType !== self.RoleTypeEnum.MASTER) {
			return;
		}

		var studentCodeIndex = self.columns.indexOf(studentCode);

		if (self.currentNode.disabledStudentCodes && studentCodeIndex !== -1) {
			self.columns.splice(studentCodeIndex, 1);
		} else if (!self.currentNode.disabledStudentCodes && studentCodeIndex === -1) {
			self.columns.splice(studentCodeInsertIndex, 0, studentCode);
		}

		self.batchErrors = [];
		self.userData = [];
		self.formattedUserData = [];
	});

	$scope.$watch("vm.userData", function userDataWatch() {
		if (self.userData.length) {
			var checkedUserData = [];
			var duplicateIndices = {};

			for (var i = 0; i < self.userData.length; i++) {
				var formattedData = angular.copy(self.userData[i]);
				var accessibilityCodes = self.userData[i].accessibilityCodes.trim();
				formattedData.accessibilitySettings = {
					textToSpeech: accessibilityCodes.indexOf(self.AccessibilityCodes.TEXT_TO_SPEECH) !== -1,
					audioFiles: accessibilityCodes.indexOf(self.AccessibilityCodes.AUDIO_FILES) !== -1,
					extendedTime: accessibilityCodes.indexOf(self.AccessibilityCodes.EXTENDED_TIME) !== -1,
					spellcheck: accessibilityCodes.indexOf(self.AccessibilityCodes.SPELLCHECK) !== -1,
					immersiveReader: accessibilityCodes.indexOf(self.AccessibilityCodes.IMMERSIVE_READER) !== -1,
				};

				if (self.currentNode.disabledStudentCodes) {
					formattedData.studentCode = formattedData.email;
				}

				checkedUserData.push(formattedData);

				if (duplicateIndices[formattedData.email]) {
					duplicateIndices[formattedData.email].push(i + 1);
				} else {
					duplicateIndices[formattedData.email] = [i + 1];
				}
			}

			self.formattedUserData = checkedUserData;
			Object.keys(duplicateIndices).forEach(function forEachFn(k) {
				if (duplicateIndices[k].length > 1) {
					self.batchErrors.push(dxLocalize.get("ImportStudents.Error.DuplicateEmails", duplicateIndices[k].join(", ")));
				}
			});

			// Clear userData so that if the same data is pasted again the watch would get triggered
			// and any error message regarding duplicates would show.
			self.userData = [];
		}
	}, true);

	$scope.$watch("vm.formattedUserData", function formattedUserDataChanged() {
		self.isPasswordUsed = self.formattedUserData.some(function someFn(u) {
			return u.password;
		});
	});

	self.importStudents = function importStudents() {
		if (self.isImportingStudents) {
			return;
		}

		self.isImportingStudents = true;

		var data = {
			organizationId: self.currentNode.id,
			students: self.formattedUserData,
		};

		dxApi.v1.students.import(data).then(function success(response) {
			self.job = response.data;

			if (self.role.roleType === self.RoleTypeEnum.MASTER) {
				self.userData = [];
				self.formattedUserData = [];
				self.importStatus = "running";
				self.hasImportedStudents = true;
				self.isImportingStudents = false;
				dxApi.v1.jobs.get(self.job.id).then(updateCounter);
			} else {
				$location.path(self.Urls.get("jobsView", {jobId: self.job.id}));
			}
		}, function reject() {
			self.batchErrors.push(dxLocalize.get("ImportStudents.Error.UnexpectedError"));
		});
	};

	self.toggleExample = function toggleExample() {
		self.exampleVisible = !self.exampleVisible;
	};

	function updateCounter(response) {
		self.job = response.data;
		if (self.job.status !== "done" && !scopeDestroyed) {
			refreshTimeout = $timeout(function reloadJob() {
				dxApi.v1.jobs.get(self.job.id).then(updateCounter);
			}, 1000);
		} else {
			$timeout.cancel(refreshTimeout);
			refreshTimeout = null;
			self.importStatus = "complete";
		}
	}

	$scope.$on("$destroy", function onScopeDestroy() {
		scopeDestroyed = true;

		if (refreshTimeout) {
			$timeout.cancel(refreshTimeout);
		}
	});
});
